// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2vvAp","loaderOuter":"PageOverlayLoader_loaderOuter__2YHDe"};